import SUBMISSION_OF_NEW_TITLES from './SubmissionofNewTitles';
import SUBMISSION_OF_TRAILERS_PROMOTIONAL_MATERIALS from './SubmissionofTrailersPromotionalMaterials';
import SUBMISSION_OF_REPEAT_TITLES_WITH_IDENTICAL_CONTENT from './SubmissionofRepeatTitlesWithIdenticalContent';
import SUBMISSION_OF_NEW_TITLES_FOR_EXPRESS_SERVICE from './SubmissionofNewTitlesForExpressService';
import SUBMISSION_OF_TITLES_FOR_RECLASSIFICATION from './SubmissionofTitlesForReClassification';
import SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT from './SubmissionOfFilmsWithPartyPoliticalContent';
import SUBMISSION_OF_TITLES_TO_OBTAIN_AN_INDICATIVE_RATING from './SubmissionofTitlesToObtainAnIndicativeRating';

const FilmClassificationforPublicExhibition = [
    {
        formID: 'submissionOfNewTitles',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_NEW_TITLES,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofTrailers/PromotionaMaterials',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_TRAILERS_PROMOTIONAL_MATERIALS,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofRepeatTitlesWithIdenticalContent',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_REPEAT_TITLES_WITH_IDENTICAL_CONTENT,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofNewTitlesForExpressService',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_NEW_TITLES_FOR_EXPRESS_SERVICE,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofTitlesForRe-classification',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_TITLES_FOR_RECLASSIFICATION,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionOfFilmsWithPartyPoliticalContent',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofTitlesToObtainAnIndicativeRating',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_TITLES_TO_OBTAIN_AN_INDICATIVE_RATING,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    }
];

export default FilmClassificationforPublicExhibition;
